import {
  BatchSummary,
  BatchProgress,
  ImportConnectionsResult,
  MatchQueueItem,
  BrandOrg
} from '../../models/market-research.model';

export interface MarketResearchState {
  batches: BatchSummary[];
  batchProgress: BatchProgress | null;
  reviewItems: MatchQueueItem[];
  autoMatched: MatchQueueItem[];
  /** NO_MATCH / AUTO_REJECTED rows — the only source for these, since /review and /auto-matched drop them. */
  noMatchItems: MatchQueueItem[];
  /**
   * Every row in the batch regardless of status. No endpoint returns CONFIRMED rows on its
   * own, so "All" is fetched directly rather than merged from reviewItems/autoMatched/
   * noMatchItems — that merge would silently drop a row the moment it's confirmed.
   */
  allQueueItems: MatchQueueItem[];
  currentBatchId: string | null;
  totalNeedsReview: number | null;
  isLoading: boolean;
  isMatching: boolean;
  error: string | null;
  mode: 'upload' | 'load';
  reviewTab: 'needs' | 'auto';
  uploadProgress: 'idle' | 'uploading' | 'processing' | 'done';
  currentStep: 1 | 2 | 3 | 4;
  selectedBrand: BrandOrg | null;
  uploadFile: File | null;
  brandOptions: BrandOrg[];
  resumeBrandOptions: BrandOrg[];
  importCompleted: boolean;
  importMode: 'MERGE' | 'REPLACE' | null;
  importResult: ImportConnectionsResult | null;
}

export const initialState: MarketResearchState = {
  batches: [],
  batchProgress: null,
  reviewItems: [],
  autoMatched: [],
  noMatchItems: [],
  allQueueItems: [],
  currentBatchId: null,
  totalNeedsReview: null,
  isLoading: false,
  isMatching: false,
  error: null,
  mode: 'upload',
  reviewTab: 'needs',
  uploadProgress: 'idle',
  currentStep: 1,
  selectedBrand: null,
  uploadFile: null,
  brandOptions: [],
  resumeBrandOptions: [],
  importCompleted: false,
  importMode: null,
  importResult: null,
};
